import React from 'react';
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Bolanir - Libreria e Cartoleria Blog</title>
        <meta name="description" content="Bolanir - Il tuo blog dedicato alla letteratura, libri curati e cancelleria di qualita. Scopri recensioni, consigli di lettura e novita editoriali." />
      </Helmet>

      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ color: '#2d4a3e', borderBottom: '2px solid #2d4a3e', paddingBottom: '10px' }}>
        Termini e Condizioni d'Uso
      </h1>
      
      <p style={{ color: '#666', marginBottom: '20px' }}>
        <strong>Data di entrata in vigore:</strong> {new Date().toLocaleDateString('it-IT')}
      </p>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>1. Accettazione dei Termini</h2>
        <p>
          Benvenuto su Bolanir, il blog dedicato alla letteratura, libri curati e cancelleria di qualità. 
          Accedendo e utilizzando questo sito web (www.bolanir.com), accetti di essere vincolato dai 
          presenti Termini e Condizioni d'Uso, da tutte le leggi e i regolamenti applicabili e accetti 
          di essere responsabile del rispetto di tutte le leggi locali applicabili.
        </p>
        <p>
          Se non accetti uno qualsiasi di questi termini, ti è vietato utilizzare o accedere a questo sito. 
          I materiali contenuti in questo sito web sono protetti dalle leggi sul diritto d'autore e sui 
          marchi applicabili.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>2. Definizioni</h2>
        <ul style={{ lineHeight: '1.8' }}>
          <li><strong>"Sito"</strong> o <strong>"Bolanir"</strong>: si riferisce al sito web www.bolanir.com e a tutti i suoi contenuti</li>
          <li><strong>"Utente"</strong> o <strong>"tu"</strong>: si riferisce a chiunque acceda o utilizzi il Sito</li>
          <li><strong>"Contenuti"</strong>: articoli, recensioni, immagini, video e qualsiasi altro materiale presente sul Sito</li>
          <li><strong>"Servizi"</strong>: tutti i servizi offerti attraverso il Sito, inclusi blog, newsletter e commenti</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>3. Licenza d'Uso</h2>
        <h3 style={{ color: '#4a5d54', marginTop: '15px' }}>3.1 Concessione della licenza</h3>
        <p>
          È concesso il permesso di scaricare temporaneamente una copia dei materiali (informazioni o software) 
          sul Sito di Bolanir solo per la visualizzazione personale e non commerciale. Questa è la concessione 
          di una licenza, non un trasferimento di titolo, e sotto questa licenza non puoi:
        </p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Modificare o copiare i materiali</li>
          <li>Utilizzare i materiali per scopi commerciali o per qualsiasi visualizzazione pubblica</li>
          <li>Tentare di decodificare o decompilare qualsiasi software contenuto nel Sito</li>
          <li>Rimuovere eventuali avvisi di copyright o altre notazioni proprietarie dai materiali</li>
          <li>Trasferire i materiali a un'altra persona o "replicare" i materiali su qualsiasi altro server</li>
        </ul>

        <h3 style={{ color: '#4a5d54', marginTop: '15px' }}>3.2 Cessazione della licenza</h3>
        <p>
          Questa licenza terminerà automaticamente se violi una qualsiasi di queste restrizioni e può essere 
          revocata da Bolanir in qualsiasi momento. Al termine della visualizzazione di questi materiali o 
          alla cessazione di questa licenza, devi distruggere tutti i materiali scaricati in tuo possesso, 
          sia in formato elettronico che stampato.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>4. Proprietà Intellettuale</h2>
        <p>
          Tutti i contenuti presenti sul Sito, inclusi ma non limitati a testi, grafiche, loghi, icone, 
          immagini, clip audio, download digitali e compilazioni di dati, sono di proprietà di Bolanir 
          o dei suoi fornitori di contenuti e sono protetti dalle leggi italiane e internazionali sul 
          diritto d'autore.
        </p>
        <p>
          Il nome "Bolanir", il logo e tutti i marchi correlati sono marchi registrati o marchi di Bolanir 
          e non possono essere utilizzati senza previa autorizzazione scritta.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>5. Contenuti Generati dagli Utenti</h2>
        <h3 style={{ color: '#4a5d54', marginTop: '15px' }}>5.1 Commenti e recensioni</h3>
        <p>
          Gli utenti possono pubblicare commenti, recensioni e altri contenuti sul Sito. Pubblicando 
          contenuti, garantisci e dichiari che:
        </p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Possiedi o hai il diritto di utilizzare il contenuto che pubblichi</li>
          <li>Il contenuto non viola i diritti di terzi</li>
          <li>Il contenuto non è diffamatorio, offensivo o illegale</li>
          <li>Il contenuto non contiene virus o codice dannoso</li>
        </ul>

        <h3 style={{ color: '#4a5d54', marginTop: '15px' }}>5.2 Licenza sui contenuti degli utenti</h3>
        <p>
          Pubblicando contenuti sul Sito, concedi a Bolanir una licenza mondiale, non esclusiva, 
          esente da royalty e trasferibile per utilizzare, riprodurre, distribuire, preparare opere 
          derivate, visualizzare ed eseguire tali contenuti in relazione al Sito e all'attività di Bolanir.
        </p>

        <h3 style={{ color: '#4a5d54', marginTop: '15px' }}>5.3 Moderazione</h3>
        <p>
          Bolanir si riserva il diritto, ma non l'obbligo, di monitorare, modificare o rimuovere 
          qualsiasi contenuto generato dagli utenti che riteniamo violi questi Termini o sia altrimenti 
          discutibile.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>6. Condotta dell'Utente</h2>
        <p>Utilizzando il Sito, accetti di NON:</p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Violare leggi, regolamenti o diritti di terzi</li>
          <li>Pubblicare contenuti falsi, ingannevoli, diffamatori o offensivi</li>
          <li>Utilizzare il Sito per spam o pubblicità non autorizzata</li>
          <li>Tentare di ottenere accesso non autorizzato al Sito o ai suoi sistemi</li>
          <li>Interferire con il funzionamento del Sito o dei server</li>
          <li>Raccogliere informazioni su altri utenti senza consenso</li>
          <li>Impersonare altre persone o entità</li>
          <li>Utilizzare bot, spider o altri dispositivi automatizzati</li>
          <li>Caricare virus o codice dannoso</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>7. Account Utente</h2>
        <p>
          Per accedere ad alcune funzionalità del Sito, potrebbe essere necessario creare un account. 
          Sei responsabile di:
        </p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Mantenere la riservatezza delle credenziali del tuo account</li>
          <li>Tutte le attività che si verificano con il tuo account</li>
          <li>Notificarci immediatamente di qualsiasi uso non autorizzato</li>
          <li>Fornire informazioni accurate e aggiornate</li>
        </ul>
        <p>
          Bolanir si riserva il diritto di sospendere o terminare account che violano questi Termini 
          o per altri motivi a nostra discrezione.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>8. Collegamenti a Siti di Terze Parti</h2>
        <p>
          Il Sito può contenere collegamenti a siti web di terze parti (editori, librerie, rivenditori 
          di cancelleria) che non sono posseduti o controllati da Bolanir. Non abbiamo controllo su, 
          e non assumiamo alcuna responsabilità per, il contenuto, le politiche sulla privacy o le 
          pratiche di qualsiasi sito web di terze parti.
        </p>
        <p>
          Riconoscendo l'uso del Sito, liberi Bolanir da qualsiasi responsabilità derivante dall'uso 
          di siti web di terze parti.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>9. Esclusione di Garanzie</h2>
        <p>
          I materiali sul Sito di Bolanir sono forniti "così come sono". Bolanir non offre garanzie, 
          espresse o implicite, e con la presente esclude e nega tutte le altre garanzie, incluse, 
          senza limitazione, garanzie implicite o condizioni di commerciabilità, idoneità per uno 
          scopo particolare o non violazione di proprietà intellettuale o altra violazione di diritti.
        </p>
        <p>
          Inoltre, Bolanir non garantisce o fa alcuna dichiarazione riguardo all'accuratezza, ai 
          risultati probabili o all'affidabilità dell'uso dei materiali sul suo sito web o altrimenti 
          relativi a tali materiali o su qualsiasi sito collegato a questo sito.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>10. Limitazione di Responsabilità</h2>
        <p>
          In nessun caso Bolanir o i suoi fornitori saranno responsabili per eventuali danni 
          (inclusi, senza limitazione, danni per perdita di dati o profitto, o dovuti a interruzione 
          dell'attività) derivanti dall'uso o dall'impossibilità di utilizzare i materiali sul Sito 
          di Bolanir, anche se Bolanir o un rappresentante autorizzato di Bolanir è stato avvisato 
          verbalmente o per iscritto della possibilità di tali danni.
        </p>
        <p>
          La responsabilità massima di Bolanir verso di te per qualsiasi causa sarà limitata 
          all'importo da te pagato, se presente, per l'accesso al Sito.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>11. Precisione dei Materiali</h2>
        <p>
          I materiali visualizzati sul Sito di Bolanir potrebbero includere errori tecnici, 
          tipografici o fotografici. Bolanir non garantisce che uno qualsiasi dei materiali sul 
          suo sito web sia accurato, completo o attuale. Bolanir può apportare modifiche ai materiali 
          contenuti sul suo sito web in qualsiasi momento senza preavviso. Tuttavia, Bolanir non si 
          impegna ad aggiornare i materiali.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>12. Newsletter e Comunicazioni</h2>
        <p>
          Iscrivendoti alla nostra newsletter, acconsenti a ricevere comunicazioni periodiche via 
          email riguardanti:
        </p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Nuovi articoli e recensioni di libri</li>
          <li>Consigli di lettura e novità editoriali</li>
          <li>Aggiornamenti su prodotti di cancelleria</li>
          <li>Offerte speciali e promozioni</li>
        </ul>
        <p>
          Puoi annullare l'iscrizione in qualsiasi momento cliccando sul link di disiscrizione 
          presente in ogni email o contattandoci direttamente.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>13. Programmi di Affiliazione</h2>
        <p>
          Bolanir partecipa a programmi di affiliazione con editori, librerie online e rivenditori 
          di cancelleria. Alcuni link presenti sul Sito possono essere link di affiliazione, il che 
          significa che potremmo ricevere una commissione se effettui un acquisto tramite tali link, 
          senza costi aggiuntivi per te.
        </p>
        <p>
          Le nostre recensioni e raccomandazioni sono sempre oneste e basate sulla nostra esperienza 
          e opinione, indipendentemente da eventuali compensi di affiliazione.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>14. Privacy e Protezione dei Dati</h2>
        <p>
          Il tuo utilizzo del Sito è anche regolato dalla nostra Informativa sulla Privacy. 
          Ti invitiamo a leggere attentamente la nostra Privacy Policy per comprendere come 
          raccogliamo, utilizziamo e proteggiamo le tue informazioni personali.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>15. Modifiche ai Termini</h2>
        <p>
          Bolanir si riserva il diritto di rivedere questi Termini e Condizioni d'Uso in qualsiasi 
          momento senza preavviso. Utilizzando questo sito web, accetti di essere vincolato dalla 
          versione corrente di questi Termini e Condizioni d'Uso.
        </p>
        <p>
          È tua responsabilità rivedere periodicamente questi Termini. L'uso continuato del Sito 
          dopo la pubblicazione di modifiche costituirà l'accettazione di tali modifiche.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>16. Indennità</h2>
        <p>
          Accetti di indennizzare, difendere e tenere indenne Bolanir, i suoi dirigenti, direttori, 
          dipendenti e agenti da e contro qualsiasi reclamo, responsabilità, danni, perdite e spese, 
          incluse, senza limitazione, ragionevoli spese legali e contabili, derivanti da o in qualsiasi 
          modo connessi con:
        </p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Il tuo accesso o utilizzo del Sito</li>
          <li>La tua violazione di questi Termini</li>
          <li>La tua violazione di qualsiasi diritto di terzi</li>
          <li>Contenuti che hai pubblicato sul Sito</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>17. Risoluzione delle Controversie</h2>
        <h3 style={{ color: '#4a5d54', marginTop: '15px' }}>17.1 Legge applicabile</h3>
        <p>
          Questi Termini e Condizioni sono regolati e interpretati in conformità con le leggi 
          italiane, senza riguardo alle disposizioni sui conflitti di legge.
        </p>

        <h3 style={{ color: '#4a5d54', marginTop: '15px' }}>17.2 Giurisdizione</h3>
        <p>
          Qualsiasi controversia derivante da o relativa a questi Termini sarà soggetta alla 
          giurisdizione esclusiva dei tribunali italiani competenti.
        </p>

        <h3 style={{ color: '#4a5d54', marginTop: '15px' }}>17.3 Risoluzione amichevole</h3>
        <p>
          Prima di intraprendere qualsiasi azione legale, le parti si impegnano a tentare di 
          risolvere qualsiasi controversia attraverso negoziazioni in buona fede.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>18. Divisibilità</h2>
        <p>
          Se una qualsiasi disposizione di questi Termini viene ritenuta invalida o inapplicabile 
          da un tribunale, le restanti disposizioni di questi Termini rimarranno in vigore. 
          La mancata applicazione di qualsiasi diritto o disposizione di questi Termini non sarà 
          considerata una rinuncia a tali diritti.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>19. Disposizioni Finali</h2>
        <p>
          Questi Termini e Condizioni, insieme all'Informativa sulla Privacy e alla Cookie Policy, 
          costituiscono l'intero accordo tra te e Bolanir riguardo all'utilizzo del Sito e sostituiscono 
          tutti gli accordi precedenti o contemporanei.
        </p>
        <p>
          Il mancato esercizio o l'applicazione di qualsiasi diritto o disposizione di questi Termini 
          da parte di Bolanir non costituirà una rinuncia a tale diritto o disposizione.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d4a3e', marginTop: '20px' }}>20. Contatti</h2>
        <p>
          Per domande sui presenti Termini e Condizioni, contattaci:
        </p>
        <ul style={{ lineHeight: '1.8', listStyle: 'none', paddingLeft: 0 }}>
          <li><strong>Email:</strong> <a href="mailto:bolanir@hotmail.com">bolanir@hotmail.com</a></li>
          <li><strong>Email legale:</strong> <a href="mailto:bolanir@hotmail.com">bolanir@hotmail.com</a></li>
          <li><strong>Sito web:</strong> www.bolanir.com</li>
        </ul>
      </section>

      <div style={{ marginTop: '40px', padding: '20px', backgroundColor: '#f5f5f5', borderLeft: '4px solid #2d4a3e' }}>
        <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
          <strong>Ultima modifica:</strong> {new Date().toLocaleDateString('it-IT')}<br />
          Utilizzando Bolanir, confermi di aver letto, compreso e accettato questi Termini e Condizioni d'Uso.
        </p>
      </div>
    </div>
  
    </>);
};

export default TermsConditions;